import type { Faq, MarketTicker, NavLink, Product, Step } from '../types/landing';

export const navLinks: NavLink[] = [
  { label: 'Comprar Crypto', href: '#productos' },
  { label: 'Mercados', href: '#mercados' },
  { label: 'Trading', href: '#trading' },
  { label: 'Herramientas', href: '#productos' },
  { label: 'Finanzas', href: '#pasos' },
  { label: 'Descubrir', href: '#faq' },
];

export const tickers: MarketTicker[] = [
  { pair: 'BTC/USDT', change: 2.45, price: '—', trend: [4, 6, 5, 8, 7, 11, 10, 14, 13, 17] },
  { pair: 'ETH/USDT', change: 1.82, price: '—', trend: [6, 5, 7, 6, 9, 8, 11, 10, 12, 14] },
  { pair: 'SOL/USDT', change: 3.14, price: '—', trend: [3, 5, 4, 7, 9, 8, 12, 15, 14, 18] },
  { pair: 'XRP/USDT', change: -0.42, price: '—', trend: [12, 11, 13, 10, 11, 9, 10, 8, 9, 8] },
];

export const products: Product[] = [
  {
    number: '01',
    title: 'Comprar Crypto',
    description: 'Explora las opciones disponibles para comprar activos digitales.',
    icon: 'wallet',
  },
  {
    number: '02',
    title: 'Spot Trading',
    description: 'Accede a mercados spot disponibles en la plataforma.',
    icon: 'candles',
  },
  {
    number: '03',
    title: 'Derivados',
    description: 'Explora productos derivados disponibles para usuarios elegibles.',
    icon: 'layers',
  },
  {
    number: '04',
    title: 'Copy Trading',
    description: 'Conoce las herramientas de copy trading disponibles.',
    icon: 'users',
  },
  {
    number: '05',
    title: 'Earn',
    description: 'Explora productos disponibles para determinados activos y usuarios.',
    icon: 'coins',
  },
  {
    number: '06',
    title: 'Herramientas',
    description: 'Descubre herramientas diseñadas para ayudarte a analizar y gestionar tu actividad.',
    icon: 'tools',
  },
];

export const tradingBenefits = [
  'Interfaz moderna',
  'Información de mercado',
  'Herramientas de trading',
  'Experiencia multi-producto',
];

export const steps: Step[] = [
  {
    number: '01',
    title: 'Crea tu cuenta',
    description: 'Utiliza mi enlace de referido y completa el registro.',
  },
  {
    number: '02',
    title: 'Verifica tu cuenta',
    description: 'Completa los procesos solicitados por la plataforma.',
  },
  {
    number: '03',
    title: 'Explora Bybit',
    description: 'Conoce los productos y herramientas disponibles para tu cuenta y región.',
  },
];

export const faqs: Faq[] = [
  {
    question: '¿Qué es Bybit?',
    answer:
      'Bybit es una plataforma de activos digitales que ofrece distintos productos relacionados con criptomonedas, como mercados spot, derivados y herramientas de trading. La disponibilidad de cada producto depende de la región y del tipo de cuenta.',
  },
  {
    question: '¿Cómo puedo crear una cuenta?',
    answer:
      'Puedes iniciar el registro desde el enlace de referido de esta página. El proceso lo gestiona directamente Bybit y suele requerir un correo electrónico o número de teléfono, además de los pasos de verificación que la plataforma solicite.',
  },
  {
    question: '¿Qué es un enlace de referido?',
    answer:
      'Es un enlace personal que identifica a quien recomienda la plataforma. Al registrarte con él, la plataforma puede asociar tu registro a ese referidor según las condiciones de su programa.',
  },
  {
    question: '¿Por qué utilizar este enlace?',
    answer:
      'Si esta página te resultó útil para conocer la plataforma, usar el enlace es una forma de apoyar el contenido. No cambia el proceso de registro ni las condiciones que aplica Bybit.',
  },
  {
    question: '¿Qué productos ofrece Bybit?',
    answer:
      'Entre otros, compra de criptomonedas, mercados spot, productos derivados, copy trading, bots y herramientas de análisis. La oferta concreta depende de la disponibilidad y elegibilidad de cada usuario.',
  },
  {
    question: '¿Puedo utilizar Bybit desde mi país?',
    answer:
      'La disponibilidad varía según la jurisdicción y las políticas vigentes de la plataforma. Debes consultar directamente los términos y las restricciones publicadas por Bybit para tu país.',
  },
  {
    question: '¿Qué necesito para registrarme?',
    answer:
      'Normalmente un correo electrónico o teléfono y una contraseña, además de completar los procesos de verificación que la plataforma solicite. Los requisitos exactos los define Bybit.',
  },
  {
    question: '¿El trading de criptomonedas tiene riesgos?',
    answer:
      'Sí. Los precios de los activos digitales son volátiles y puedes perder parte o la totalidad de tu capital. Nada de lo publicado en esta página es asesoramiento financiero.',
  },
  {
    question: '¿Cómo funcionan las recompensas de referidos?',
    answer:
      'Las recompensas, cuando existen, las define y gestiona la propia plataforma. Dependen del programa, la campaña, la región y los requisitos vigentes en cada momento.',
  },
];

export const footerLinks: NavLink[] = [
  { label: 'Mercados', href: '#mercados' },
  { label: 'Trading', href: '#trading' },
  { label: 'Herramientas', href: '#productos' },
  { label: 'FAQ', href: '#faq' },
];

export const footerDisclaimers = [
  'Esta página es independiente y puede contener enlaces de referido. Si te registras mediante nuestro enlace, podemos recibir una compensación de acuerdo con el programa correspondiente.',
  'Los productos, servicios, promociones y recompensas pueden variar según disponibilidad, jurisdicción, elegibilidad y condiciones vigentes.',
  'Las criptomonedas y los productos de trading implican riesgos significativos. Puedes perder parte o la totalidad de tu capital.',
];
